import { useQuery } from '@tanstack/react-query';
import { LoyaltyUser } from '@winelivery-org/wl-client-sdk-js';
import moment from 'moment';
import { useTranslations } from 'next-intl';
import { getEventsByUser } from '../../../../services/loyalty';
import useSession from '../../../../stores/session/useSession';

interface Props {
  loyalty?: LoyaltyUser;
}

export default function SectionStatistics(props: Props) {
  const { user } = useSession();

  const { data } = useQuery({
    queryKey: ['wallet-events', user?._id],
    queryFn: () => getEventsByUser(user!._id),
    enabled: !!user?._id,
  });
  const t = useTranslations('loyalty');

  if (!user || !data || !props.loyalty || 'status_code' in data.data) {
    return null;
  }

  return (
    <div
      id="movements"
      className="tw-mb-16 tw-p-4 tw-max-w-5xl tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8"
    >
      <h3 className="tw-text-4xl tw-font-bold tw-text-greyscale-title tw-tracking-tighter tw-m-0 tw-p-0">
        {t('wallet.statistics.title')}
      </h3>
      <div className="tw-w-full tw-grid sm:tw-grid-cols-4 tw-gap-6">
        <div
          className={
            'sm:tw-col-span-3 tw-rounded-2xl tw-pb-0 tw-border tw-bg-greyscale-offwhite tw-p-4 tw-flex'
          }
        >
          <table className="tw-w-full tw-gap-8 tw-table-auto">
            <thead>
              <tr>
                <th className={'tw-pb-4'}>{t('wallet.statistics.th.0')}</th>
                <th className={'tw-pb-4'}>{t('wallet.statistics.th.1')}</th>
                <th className={'tw-pb-4'}>{t('wallet.statistics.th.2')}</th>
              </tr>
            </thead>
            <tbody>
              {data.data.events.map((e) => (
                <tr className={'tw-border-t'}>
                  <td className={'tw-text-sm tw-font-medium tw-py-4'}>
                    {/* @ts-ignore*/}
                    {e.description}
                  </td>
                  <td className={'tw-text-sm tw-text-gray-600'}>
                    {moment(e.createdAt).format('DD/MM/yyyy, HH:mm')}
                  </td>
                  <td
                    className={`tw-font-bold tw-text-sm tw-text-gray-600 ${
                      e.operationType === 'increment'
                        ? 'tw-text-green-500'
                        : 'tw-text-red-500'
                    }`}
                  >
                    {e.operationType === 'increment' ? '+' : '-'}
                    {e.points}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="tw-col-span-1 tw-flex tw-flex-col tw-gap-6 sm:tw-gap-6">
          <div className="tw-bg-greyscale-offwhite tw-border tw-border-greyscale-separator tw-rounded-2xl tw-px-2 tw-py-4 tw-text-center tw-space-y-2">
            <h5 className="tw-text-3xl tw-font-bold tw-tracking-tighter tw-text-primary-dark tw-m-0">
              {props.loyalty.referral?.usersSignedUp.length || 0}
            </h5>
            <p className="tw-text-sm tw-font-medium tw-tracking-tight tw-text-primary-dark">
              {t('wallet.statistics.friendsInvited')}
            </p>
          </div>
          <div className="tw-bg-greyscale-offwhite tw-border tw-border-greyscale-separator tw-rounded-2xl tw-px-2 tw-py-4 tw-text-center tw-space-y-2">
            <h5 className="tw-text-3xl tw-font-bold tw-tracking-tighter tw-text-primary-dark tw-m-0">
              {props.loyalty.referral?.usersOrdered.length || 0}
            </h5>
            <p className="tw-text-sm tw-font-medium tw-tracking-tight tw-text-primary-dark">
              {t('wallet.statistics.firstPurchases')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
